var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-between flex-column pay-box"},[_c('div',{staticClass:"pay-top border-bm"},[_vm._t("top")],2),_c('div',{staticClass:"pay-money"},[_vm._t("money")],2),_c('div',{staticClass:"flex-1 pay-center"},[_vm._t("center")],2),_c('div',{staticClass:"pay-bottom"},[_vm._t("bottom")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }